/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metrics_WatchersInputs */



/**
* | output |
* | --- |
* | "watchers" |
*
* @param {Metrics_WatchersInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const metrics_watchers = /** @type {((inputs?: Metrics_WatchersInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metrics_WatchersInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("watchers")
});